import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as summit from '../summit'

export const RESOURCE = {
  payload: {
    alias: 'pulse',
    appAlias: summit.RESOURCE.payload.alias,
    description: 'Check in on your team',
    display: {
      isMain: true,
      position: 0,
    },
    name: 'Pulse',
    page: { id: prebuilt.Page.Id.SummitPulse },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
